// Libraries
import React from 'react';
import { ThemeProvider } from 'styled-components';
// Components | Utils
import UserContextProvider from './contexts/UserContext';
import DesktopContextProvider from './contexts/DesktopContext';
import GameContextProvider from './contexts/GameContext';
import SolitaireGame from './views/SolitaireGame';
import { theme } from './globalStyles';

function App() {
  return (
    <UserContextProvider>
      <ThemeProvider theme={theme}>
        <DesktopContextProvider>
          <GameContextProvider>
            <SolitaireGame />
          </GameContextProvider>
        </DesktopContextProvider>
      </ThemeProvider>
    </UserContextProvider>
  );
}

export default App;
